import swal from "sweetalert";
import axiosInstance from "../api";
import {setGetCustomerMembershipData } from "../reusable/reusableSlice";


export const getCustomerMembership = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("membership/list_user_membership",data);
      if (response?.data) {
        dispatch(setGetCustomerMembershipData(response?.data?.response))
      } else {
        dispatch(setGetCustomerMembershipData([]))
      }
      return response.data
    } catch (err) {
      console.error(err);
      dispatch(setGetCustomerMembershipData([]))
    }
  };

  export const addCustomerMembershipData = (data, setLoading,navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("membership/add_user_membership", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        navigate("/customermembership")
        // return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };



 

  export const deleteOneMembership = (id) => async (dispatch) => {
    // setLoading(true);
    try {
      const response = await axiosInstance.delete(`membership/delete/${id}`);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // navigate("/membership")
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false);
    }
  };